import { render, staticRenderFns } from "./logsmain.vue?vue&type=template&id=1b595efb&scoped=true"
import script from "./logsmain.vue?vue&type=script&lang=js"
export * from "./logsmain.vue?vue&type=script&lang=js"
import style0 from "./logsmain.vue?vue&type=style&index=0&id=1b595efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b595efb",
  null
  
)

export default component.exports